import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { authConfig } from 'config/auth.config';

@Injectable({providedIn: 'root'})
export class AuthService {

    constructor(private oAuthService: OAuthService) {}

    public initAuth(): (() => Promise<void>) {
        return () => new Promise<void>((res, rej) => {
            this.oAuthService.configure(authConfig);
            this.oAuthService.tokenValidationHandler = new JwksValidationHandler();
            this.oAuthService.loadDiscoveryDocumentAndTryLogin().then((connected) => {
                this.oAuthService.setupAutomaticSilentRefresh();
                res();
            });
        });
    }

}